import keyMirror from "keymirror";

import AuthorType from "./AuthorTypes";

const { BOT, EXPERT, POSTER, SYSTEM } = AuthorType;

export const messageTypeToAuthorMap = {
    Answer: EXPERT,
    AutoResponseMessage: BOT,
    Question: POSTER,
    ResponseMessage: POSTER,

    /*
     * System messages
     */
    CustomerReroutePromptSystemMessage: SYSTEM,
    CustomerReroutePromptCustomSystemMessage: SYSTEM,
    CustomerReroutePromptBeforeClaimSystemMessage: SYSTEM,
    AcceptResponseSystemMessage: SYSTEM,
    AcceptResponseConfirmationMessage: SYSTEM,
    AutoResponseConfirmationMessage: SYSTEM,
    RejectedAutoResponseMessage: SYSTEM,
    RejectedByUserBlockedQuestionSystemMessage: SYSTEM,
    RejectedAutoResponseMessageChatbotPing: SYSTEM,
    OpenedAutoResponseMessage: SYSTEM,
    NotifyingExpertsSystemMessage: SYSTEM,
    QuestionExpiredSystemMessage: SYSTEM,
    QuestionRejectedByKeywordSystemMessage: SYSTEM,
    QuestionRejectedByMetadataSystemMessage: SYSTEM,
    QuestionRejectedByPredictiveRoutingSystemMessage: SYSTEM,
    QuestionRejectedByDomainSystemMessage: SYSTEM,
    QuestionRejectedByBudgetSystemMessage: SYSTEM,
    QuestionRejectedByBlockedUser: SYSTEM,
    QuestionRejectedByIpAddress: SYSTEM,
    QuestionReroutedSystemMessage: SYSTEM,
    AcceptedResponseSystemMessage: SYSTEM,
    RateResponseSystemMessage: SYSTEM,
    AddTestimonialSystemMessage: SYSTEM,
    AddedTestimonialSystemMessage: SYSTEM,
    MarkAsResolvedMessage: SYSTEM,
    ContestedMarkAsResolvedMessage: SYSTEM,
    ApprovedMarkAsResolvedMessage: SYSTEM,
    QuestionFlagSystemMessage: SYSTEM,
    ContactInfoPromptSystemMessage: SYSTEM,
    ContactInfoConfirmSystemMessage: SYSTEM,
    TranslationNoticeSystemMessage: SYSTEM,
};

export const MessageType = keyMirror(messageTypeToAuthorMap);

export default MessageType;
